"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadCouponImage = uploadCouponImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 上传优惠券图片
 * @param {FormData} formData 包含文件和路径信息的FormData对象
 * @returns {Promise}
 */
function uploadCouponImage(formData) {
  return (0, _requestAuth.default)({
    url: '/image/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}